import { useTranslation } from '@/i18n';
import {
  ActionMenu,
  ButtonV2Props,
  IconTrailing,
} from '@moneyforward/ap-frontend-components';
import { FC, useMemo } from 'react';
import { ActionMenusProps } from '../types';
import { useItems } from './useItems';

export const ActionMenus: FC<ActionMenusProps> = ({
  onExport,
  dropDownProps,
  isDisabled,
  isLoading,
}) => {
  const { t } = useTranslation();
  const items = useItems({
    onExport,
  });

  const buttonProps: ButtonV2Props = useMemo(
    () => ({
      children: t('approving_invoice_reports.export'),
      color: 'primary',
      isSecondary: true,
      isTertiary: true,
      rightIcon: <IconTrailing size={16} />,
      isDisabled,
      isLoading,
      size: 'sm',
    }),
    [isDisabled, t, isLoading]
  );

  return (
    <ActionMenu
      type='button'
      items={items}
      buttonProps={buttonProps}
      dropDownProps={dropDownProps}
    />
  );
};
